import SearchCard from "./SearchCard";
import SearchHitDepo from "./SearchHitDepo";

export default function SearchHits() {

  return <>
    <SearchHitDepo />
    <SearchCard />
  </>;
}